import {APIError} from 'helpers/Rest';
import ServerActions from "./ServerActions";

export default {
  newRegistration: (user) => async (dispatch, _getState, {api}) => {
    try {
      const registration = await api.addRegistration(user);
      dispatch(ServerActions.newRegistration(registration));
    } catch(e) {
      if (e instanceof APIError) {
        const {json, body} = e?.response ?? {};
        dispatch(ServerActions.registrationError(json ?? body));
      } else {
        throw e;
      }
    }
  },

  acceptTerms: (userId, newsletter) => async (dispatch, _getState, {api}) => {
    try {
      const acceptance = await api.addAcceptance(userId, newsletter)
      dispatch(ServerActions.newAcceptance(acceptance));
    } catch(e) {
      if (e instanceof APIError) {
        console.warn(e);
      } else {
        throw e;
      }
    }
  },
};
